import { render, staticRenderFns } from "./GroupsTableRow.vue?vue&type=template&id=22329494&lang=pug&"
import script from "./GroupsTableRow.vue?vue&type=script&lang=js&"
export * from "./GroupsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports